// Canonical display names for sales_services.service_type.
//
// History: until ~Feb 2026 services were created with snake_case slugs
// (exterior_render, spinhouse, ...). Since the service_types catalog was
// introduced, new records carry catalog display names. Legacy DB rows keep
// their slugs ON PURPOSE — the owner declined a data migration — so grouping
// and display must normalize on the fly, and write paths that copy
// task.task_type (a slug on old tasks) must normalize before saving.
const LEGACY_SERVICE_TYPE_NAMES = {
  exterior_render: "Exterior Renderings",
  interior_render: "Interior Renderings",
  aerial_view: "Aerial View Renderings",
  eye_level: "Eye Level Renderings",
  close_up: "Close Up Renderings",
  floor_plan: "2D Floor Plans",
  "2d_planning": "2D Floor Plans",
  "3d_planning": "3D Floor Plans",
  website: "Website",
  website_dev: "Website",
  "website - test": "Website",
  spinhouse: "Spinhouse Software",
  spinhouse_dev: "Spinhouse Software",
  vexos: "VEXOS",
  other: "Other",
  vr: "VR Tours (Full)",
  animation: "360° Video Sphere",
  "360° vidio sphere": "360° Video Sphere", // legacy typo
  // System types written by the Support billing backend — keep them as-is in
  // the DB (the backend dedupes on the exact slug), pretty-print only.
  support_monthly: "Support (monthly)",
  support_oneoff: "Support (one-off)",
};

export function normalizeServiceType(raw) {
  const trimmed = String(raw || "").trim();
  if (!trimmed) return "";
  return LEGACY_SERVICE_TYPE_NAMES[trimmed.toLowerCase()] || trimmed;
}

// Grouping for the SALES report (/sales-pnl): Spinhouse is sold to clients as
// ONE product — the "Spinhouse Animation ..." sub-types exist for task/artist
// workflows, not as separate client-facing products (owner, 2026-06-12).
// Display-level only; records keep their exact service_type.
export function salesReportGroup(raw) {
  const name = normalizeServiceType(raw);
  if (/^spinhouse/i.test(name)) return "Spinhouse";
  return name;
}
